module.exports = "/build/web/svg/social/small/verified-twitter.e44b781fd2ffe5d2e1e36b25be8d1c1d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/verified-twitter.svg
// module id = 111
// module chunks = 24